import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceTag } from './PriceTag';
import { TrustStrip } from './TrustStrip';
import { CLOSING_EYEBROW, CLOSING_LINES, CLOSING_TAIL, CLOSING_TITLE, FINAL_CTA, FINAL_LINE, FINAL_PRICE_LABEL, FINAL_PRODUCT, FINAL_SUBLINE, finalMicro } from '../data/halloweenKit';
export function FinalOfferSection() {
  return <section className="w-full bg-night-950 py-14 sm:py-20" aria-labelledby="final-title" data-id="element-77" data-mp="1qc701c1n9ipg">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-78" data-mp="1qaccdpyzncho">
        <p className="text-[11px] font-bold uppercase tracking-[0.26em] text-pumpkin" data-id="element-79" data-mp="1vc1m92ah5k46">{CLOSING_EYEBROW}</p>
        <h2 id="final-title" className="mt-3 font-display text-[1.9rem] font-semibold leading-tight text-cream-50 sm:text-[2.7rem]" data-id="element-80" data-mp="208s6m1tbb1ve">
          {CLOSING_TITLE[0]}
          <span className="block text-pumpkin-light" data-id="element-81" data-mp="17mh58oxvswxj">{CLOSING_TITLE[1]}</span>
        </h2>

        <div className="mt-6 space-y-0.5" data-id="element-82" data-mp="1ck8v7deyu8z3">
          {CLOSING_LINES.map(line => <p key={line} className="font-display text-lg italic leading-snug text-cream-100 sm:text-xl" data-id="element-83" data-mp="2chldzjtgbe50">
              {line}
            </p>)}
        </div>
        <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-body sm:text-[16px]" data-id="element-84" data-mp="27jjs6r4n50pu">{CLOSING_TAIL}</p>

        <div data-hide-sticky className="mt-9 rounded-3xl border border-pumpkin/40 bg-black px-5 py-8 sm:px-10" data-id="element-85" data-mp="22pp3tae3bxkf">
          <h3 className="font-display text-[1.45rem] font-semibold leading-tight text-cream-50 sm:text-[1.8rem]" data-id="element-86" data-mp="1tr3orp7tv0oe">
            {FINAL_PRODUCT}
          </h3>
          <p className="mx-auto mt-2 max-w-sm text-[13.5px] font-medium leading-snug text-cream-300" data-id="element-87" data-mp="1oqz5jrfjbruh">{FINAL_SUBLINE}</p>

          <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.22em] text-pumpkin" data-id="element-88" data-mp="1jv0mmjcz721g">{FINAL_PRICE_LABEL}</p>
          <PriceTag size="lg" className="mt-2" data-id="element-89" data-mp="3e78f7q1tr6u2" />

          <div className="mt-6 flex justify-center" data-id="element-90" data-mp="3e6otdy91zyar">
            <CtaButton size="md" label={FINAL_CTA} data-id="element-91" data-mp="398dkpquhvtu4" />
          </div>
          <TrustStrip items={finalMicro} className="mt-3" data-id="element-92" data-mp="39612rdoqljh2" />
        </div>

        <p className="mx-auto mt-9 max-w-md font-display text-xl italic leading-snug text-cream-50 sm:text-2xl" data-id="element-93" data-mp="17i6euwyys7co">
          {FINAL_LINE}
        </p>
      </div>
    </section>;
}